import { withRouter } from "react-router-dom";
import ModalWindowManagerComponent from "./modal-window-manager.component";
import { connect } from 'react-redux'
import {compose} from 'redux';
import { Modals } from "@components/layout/modals";

const mapStateToProps = (state, props) => ({
    modals: state.layout.modals || [],
});

const actions = {
    submitModal: Modals.actions.submitModal,
    declineModal: Modals.actions.declineModal
};

export default connect(mapStateToProps, actions)(
    compose(
        withRouter,
    )(ModalWindowManagerComponent)
);
